import React from 'react';
import { FormState } from 'final-form';
import PopupErrorForm from '../Errors/PopupErrorForm';

type ErrorComponentProps = {
  onClose?: () => void;
  formState?: FormState<any>
};

const MobilityError: React.FC<ErrorComponentProps> = ({ onClose, formState }) => {
  const errorFields = Object.keys(formState?.errors ?? {});

  const errorMessage = errorFields.includes('documents') ? {
    id: 'document.mandatoryModal.title',
    defaultMessage: 'You must first provide {count, plural, one {the document} other {all documents}} marked with "{mandatory}".',
  }: {
    id: 'questions.mandatoryModal.title',
    defaultMessage: 'You must first answer {count, plural, one {the question} other {all questions}} marked with "{mandatory}".',
  };

  return (<PopupErrorForm
    errorMessage={errorMessage}
    formState={formState}
    onClose={onClose}
  />);
};

export default MobilityError;
